export const requiredField = (value: unknown): string | void => {
  if (!value) {
    return 'This field is required';
  }
};
